// api.js

import axiosInstance from "../axiosInstance";

export const customProviderService = {
  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/custom-provider", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit, skip, searchValue) => {
    try {
      let response = await axiosInstance.get(
        `/custom-provider?$limit=${limit || 15}&$skip=${skip || 0}&${
          searchValue ? `&name[$search]=${searchValue}` : ""
        }`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (id, obj) => {
    try {
      let response = await axiosInstance.patch(`/custom-provider/${id}`, obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/custom-provider/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
